<template>
  <div>
    <el-dialog :width="Diawidth" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
      :close-on-click-modal="true" :show-close="true" :close-on-press-escape="true">
      <span slot='title' class="el-dialog__title" style="font-size: 18px;">{{bigData.title}}</span>
      <div class="Piebar">
        <span v-if="AllNum!=0" style="color: #fff; font-size: 16px;">总和：{{AllNum}}</span>
        <span v-if="bigData.type=='yjbxb' && bigData.isBar == false" style="color: #fff; font-size: 16px;">病险坝总和：{{bxNum}},病险有人坝总和：{{bxyrNum}}</span>
        <span v-if="bigData.type=='yjljb' && bigData.isBar == false" style="color: #fff; font-size: 16px;">老旧坝总和：{{bxNum}},老旧有人坝总和：{{bxyrNum}}</span>
        <span v-if="bigData.type=='yjbxljyx' && bigData.isBar == false" style="color: #fff; font-size: 16px;">老旧坝总和：{{bxNum}},病险坝总和：{{bxyrNum}}</span>
        <div v-if="ssxData" style="width: 45%; float: right;color: #fff;font-size: 16px; line-height: 30px;margin-top: 20px;">
          <p><span style="color: #00B3FE;font-weight: bold;">省清单：</span>{{ssxData.sheng.toString()}}</p>
          <p><span style="color: #00B3FE;font-weight: bold;">市清单：</span>{{ssxData.shi.toString()}}</p>
          <p><span style="color: #00B3FE;font-weight: bold;">县清单：</span>{{ssxData.xian.toString()}}</p>
        </div>
        <div class="Piebar" id="bigEcharts"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    selectshengshixianName
  } from "@/api/api.js";
  export default {
    props: ['bigData'],
    data() {
      return {
        dialogVisible: true,
        Diawidth: "91%",
        Bar: null,
        AllNum: 0,
        bxNum: 0,
        bxyrNum: 0,
        ssxData: null,
      }
    },
    mounted() {
      let _this = this;
      let mydata = this.bigData;
      this.AllNum = 0;
      this.bxNum = 0;
      this.bxyrNum = 0;
      console.log('弹窗---------->', this.bigData)
      setTimeout(function() {
        if (mydata.type == 'ybjytj') {
          _this.jytjbar(mydata.jytjCityId, mydata.jytjCityName, mydata.a10Sum, mydata.a25Sum, mydata.a50Sum, mydata.a100Sum, mydata.a250Sum, mydata.a255Sum);
        }
        if (mydata.type == 'ybssx') {
          _this.ssxbars(mydata.ssxCityName, mydata.shengCount, mydata.shiCount, mydata.xianCount);
          //调用省市县清单
          let params = {
            yuShi: _this.$store.state.yuShi
          };
          selectshengshixianName(params).then((res) => {
            _this.ssxData = res;
          });
        }
        if (mydata.type == "yjbxljyx") {
          _this.slbarNew(mydata.blCityName, mydata.bxBlueSum, mydata.bxYellowSum, mydata.bxOrangeSum, mydata.bxRedSum,
          mydata.ljBlueSum, mydata.ljYellowSum, mydata.ljOrangeSum, mydata.ljRedSum);
        } 
        if (mydata.isBar == false) {//饼图
          //预报
          if (mydata.type == 'ybydbNum') {
            _this.xzqbarNew(mydata.xzqhCityName, mydata.xzqhDxbNum, mydata.xzqhZxbNum, mydata.xzqhDxbYrNum, mydata.xzqhZxbYrNum);
          } else if (mydata.type == 'ybyxrs') {
            _this.yxrsbarNew(mydata.yxrsCityName, mydata.dxyrYdb, mydata.zxyrYdb);
          } else if (mydata.type == 'ybzyss') {
            _this.yxrsbarNew(mydata.zyssCityName, mydata.dxZyssYdb, mydata.zxZyssYdb);
          } else if (mydata.type == 'ybbxb') {
            _this.bxbbarNew(mydata.bxbCityName, mydata.bxbDxbNum, mydata.bxbZxbNum, mydata.bxbDxbYrNum, mydata.bxbZxbYrNum);
          } else if (mydata.type == 'ybljb') {
            _this.bxbbarNew(mydata.ljbCityName, mydata.ljbDxbNum, mydata.ljbZxbNum, mydata.ljbDxbYrNum, mydata.ljbZxbYrNum);
          }
          //预警
          else if (mydata.type == "yjydbNum") {
            _this.slbarNew(mydata.xzqhCityName, mydata.dxBlueSum, mydata.dxYellowSum, mydata.dxOrangeSum, mydata.dxRedSum,
            mydata.zxBlueSum, mydata.zxYellowSum, mydata.zxOrangeSum, mydata.zxRedSum);
          } else if (mydata.type == "yjbxb") {
            _this.slbarNew(mydata.bxbCityName, mydata.BblueSum, mydata.ByellowSum, mydata.BorangeSum, mydata.BredSum,
            mydata.ByblueSum, mydata.ByyellowSum, mydata.ByorangeSum, mydata.ByredSum);
          } else if (mydata.type == "yjljb") {
            _this.slbarNew(mydata.ljbCityName, mydata.LJblueSum, mydata.LJyellowSum, mydata.LJorangeSum, mydata.LJredSum,
            mydata.LJyblueSum, mydata.LJyyellowSum, mydata.LJyorangeSum, mydata.LJyredSum);
          } else if (mydata.type == "yjyxrs") {
            _this.slbarNew1(mydata.yxrsCityName, mydata.YblueSum, mydata.YyellowSum, mydata.YorangeSum, mydata.YredSum);
          } else if (mydata.type == "yjzyss") {
            _this.slbarNew1(mydata.zyssCityName, mydata.ZblueSum, mydata.ZyellowSum, mydata.ZorangeSum, mydata.ZredSum);
          }
        } else {//柱图
          //预报
          if (mydata.type == 'ybydbNum') {
            _this.xzqbar(mydata.xzqhCityId, mydata.xzqhCityName, mydata.xzqhDxbNum, mydata.xzqhZxbNum, mydata.xzqhDxbYrNum, mydata.xzqhZxbYrNum);
          } else if (mydata.type == 'ybyxrs') {
            _this.yxrsbar(mydata.yxrsCityId, mydata.yxrsCityName, mydata.dxyrYdb, mydata.zxyrYdb);
          } else if (mydata.type == 'ybzyss') {
            _this.yxrsbar(mydata.zyssCityId, mydata.zyssCityName, mydata.dxZyssYdb, mydata.zxZyssYdb);
          } else if (mydata.type == 'ybbxb') {
            _this.bxbbars(mydata.bxbCityId, mydata.bxbCityName, mydata.bxbDxbNum, mydata.bxbZxbNum, mydata.bxbDxbYrNum, mydata.bxbZxbYrNum);
          } else if (mydata.type == 'ybljb') {
            _this.bxbbars(mydata.ljbCityId, mydata.ljbCityName, mydata.ljbDxbNum, mydata.ljbZxbNum, mydata.ljbDxbYrNum, mydata.ljbZxbYrNum);
          }
          //预警
          else if (mydata.type == "yjydbNum") {
            _this.slbar(mydata.xzqhCityId, mydata.xzqhCityName, mydata.BlueSum, mydata.YellowSum, mydata.OrangeSum, mydata.RedSum);
          } else if (mydata.type == "yjbxb") {
            _this.slbar(mydata.bxbCityId, mydata.bxbCityName, mydata.BblueSum, mydata.ByellowSum, mydata.BorangeSum, mydata.BredSum);
          } else if (mydata.type == "yjljb") {
            _this.slbar(mydata.ljbCityId, mydata.ljbCityName, mydata.LJblueSum, mydata.LJyellowSum, mydata.LJorangeSum, mydata.LJredSum);
          } else if (mydata.type == "yjyxrs") {
            _this.slbar(mydata.yxrsCityId, mydata.yxrsCityName, mydata.YblueSum, mydata.YyellowSum, mydata.YorangeSum, mydata.YredSum);
          } else if (mydata.type == "yjzyss") {
            _this.slbar(mydata.zyssCityId, mydata.zyssCityName, mydata.ZblueSum, mydata.ZyellowSum, mydata.ZorangeSum, mydata.ZredSum);
          }
        }
      }, 10);
    },
    methods: {
      //预报页面淤地坝数量统计饼图
      xzqbarNew(xzqhCityName, xzqhDxbNum, xzqhZxbNum, xzqhDxbYrNum, xzqhZxbYrNum) {
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));
        this.AllNum = Number(xzqhDxbNum) + Number(xzqhZxbNum);

        let  option = {
          legend: {
            left:'center',
            top:5,
            data:[{name:"大型坝"},{name: "中型坝"},{name: "大型有人坝"},{name: "中型有人坝"}],
            textStyle:{
              color:'#fff',
              fontSize: 16
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: xzqhCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '80%'],
              label: {
                position: 'inner',
                fontSize: 16,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: xzqhDxbNum, name: "大型坝",itemStyle:{color:'#FFE557'}},
                { value: xzqhZxbNum, name: "中型坝",itemStyle:{color:'#1CEA58'}},
                { value: xzqhDxbYrNum, name: "大型有人坝",itemStyle:{color:'#00B3FE'}},
                { value: xzqhZxbYrNum, name: "中型有人坝",itemStyle:{color:'#B32EFF'}},
              ]
            },
          ]
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      //预报页面淤地坝数量统计柱图
      xzqbar(xzqhCityId, xzqhCityName, xzqhDxbNum, xzqhZxbNum, xzqhDxbYrNum, xzqhZxbYrNum) {
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));

        let option = {
          title: {
            show: false,
            text: "",
            textStyle: {
              fontSize: 25,
              fontWeight: "normal",
              color: "#fff",
            },
            x: "center",
          },

          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: "2%",
            right: "2%",
            bottom: "0%",
            top: "5%",
            containLabel: true,
          },
          legend: {
            data: ["大型坝", "中型坝", '大型有人坝', '中型有人坝'],
            /*right: 10,*/
            // top: "4%",
            textStyle: {
              color: "#fff",
              fontSize: 16
            },
            itemWidth: 12,
            itemHeight: 10,
            // itemGap: 35
          },
          xAxis: {
            type: "category",
            data: xzqhCityName,
            axisLine: {
              lineStyle: {
                color: "#ccc",
              },
            },
            axisLabel: {
              // interval: 0,
              // rotate: 40,
              textStyle: {
                fontFamily: "Microsoft YaHei",
                fontSize: 16
              },
            },
          },

          yAxis: {
            name: "数量",
            type: "value",
            // max: "150",
            axisLine: {
              show: false,
              lineStyle: {
                color: "#ccc",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,0.3)",
              },
            },
            axisLabel: {
              fontSize: 16
            },
          },

          series: [{
              name: "大型坝",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                },
              },
              data: xzqhDxbNum,
            },
            {
              name: "中型坝",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#1CEA58",
                    },
                    {
                      offset: 1,
                      color: "#1CEA58",
                    },
                  ]),
                },
              },
              data: xzqhZxbNum,
            },
            {
              name: "大型有人坝",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00B3FE",
                    },
                    {
                      offset: 1,
                      color: "#00B3FE",
                    },
                  ]),
                },
              },
              data: xzqhDxbYrNum,
            },
            {
              name: "中型有人坝",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#B32EFF",
                    },
                    {
                      offset: 1,
                      color: "#B32EFF",
                    },
                  ]),
                },
              },
              data: xzqhZxbYrNum,
            },
          ],
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      //预报页面影响人数及重要设施统计饼图
      yxrsbarNew(yxrsCityName, dxyrYdb, zxyrYdb) {
        let _this = this;
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));
        this.AllNum = Number(dxyrYdb) + Number(zxyrYdb);

        let  option = {
          legend: {
            left:'center',
            top:5,
            data:[{name:"大型坝"},{name: "中型坝"}],
            textStyle:{
              color:'#fff',
              fontSize: 16
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: yxrsCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '80%'],
              label: {
                position: 'inner',
                fontSize: 16,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: dxyrYdb, name: "大型坝",itemStyle:{color:'#FFE557'}},
                { value: zxyrYdb, name: "中型坝",itemStyle:{color:'#00B3FE'}},
              ]
            },

          ]
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      //预报页面影响人数及重要设施统计柱图
      yxrsbar(yxrsCityId, yxrsCityName, dxyrYdb, zxyrYdb) {
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '2%',
            bottom: '0%',
            top: '10%',
            containLabel: true
          },
          legend: {
            data: ['大型坝', '中型坝'],
            // right: 'center',
            top: 0,
            textStyle: {
              color: "#fff",
              fontSize: 16
            },
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 10
          },
          xAxis: {
            type: 'category',
            data: yxrsCityName,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              textStyle: {
                fontFamily: 'Microsoft YaHei',
                fontSize: 16
              }
            },
          },
          yAxis: {
            name: "数量",
            type: 'value',
            // max: '1200',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ccc'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {
              fontSize: 16
            }
          },
          series: [{
              name: '大型坝',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557 ",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                  // barBorderRadius: 5,
                },
              },
              data: dxyrYdb
            },
            {
              name: '中型坝',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00B3FE",
                    },
                    {
                      offset: 1,
                      color: "#00B3FE",
                    },
                  ]),
                  // barBorderRadius: 5,
                }
              },
              data: zxyrYdb
            },
          ]
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      //预报页面省市县统计饼图
      ssxbars(ssxCityName, shengCount, shiCount, xianCount) {
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));

        let  option = {
          legend: {
            left:'25%',
            top:5,
            data:[{name:"省"},{name: "市"}, {name: "县"}],
            textStyle:{
              color:'#fff',
              fontSize: 16
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: ssxCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '80%'],
              center: ['30%', '50%'],
              label: {
                position: 'inner',
                fontSize: 16,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: shengCount, name: "省",itemStyle:{color:'#FFE557'}},
                { value: shiCount, name: "市",itemStyle:{color:'#1CEA58'}},
                { value: xianCount, name: "县",itemStyle:{color:'#00B3FE'}},
              ]
            },
          ]
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      //预报页面病险坝及老旧坝统计饼图
      bxbbarNew(bxbCityName, bxbDxbNum, bxbZxbNum, bxbDxbYrNum, bxbZxbYrNum) {
        let _this = this;
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));
        this.AllNum = Number(bxbDxbNum) + Number(bxbZxbNum);

        let option = {
          legend: {
            left:'center',
            top:5,
            data:[{name:"大型坝"},{name: "中型坝"},{name:"大型有人坝"},{name: "中型有人坝"}],
            textStyle:{
              color:'#fff',
              fontSize: 14
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: bxbCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '80%'],
              label: {
                position: 'inner',
                fontSize: 16,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: bxbDxbNum, name: "大型坝",itemStyle:{color:'#FFE557'}},
                { value: bxbZxbNum, name: "中型坝",itemStyle:{color:'#1CEA58'}},
                { value: bxbDxbYrNum, name: "大型有人坝",itemStyle:{color:'#00B3FE'}},
                { value: bxbZxbYrNum, name: "中型有人坝",itemStyle:{color:'#B32EFF'}},
              ]
            },
          ]
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      //预报页面病险坝及老旧坝统计柱图
      bxbbars(bxbCityId, bxbCityName, bxbDxbNum, bxbZxbNum, bxbDxbYrNum, bxbZxbYrNum) {
        let _this = this;
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '2%',
            bottom: '0%',
            top: '10%',
            containLabel: true
          },
          legend: {
            data: ['大型坝', '中型坝', '大型有人坝', '中型有人坝'],
            // right: 'center',
            top: 0,
            textStyle: {
              color: "#fff",
              fontSize: 16
            },
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 10
          },
          xAxis: {
            type: 'category',
            data: bxbCityName,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              textStyle: {
                fontFamily: 'Microsoft YaHei',
                fontSize: 16
              }
            },
          },
          yAxis: {
            name: "数量",
            type: 'value',
            // max: '1200',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ccc'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {
              fontSize: 16
            }
          },
          series: [{
              name: '大型坝',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557 ",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                  // barBorderRadius: 12,
                },
              },
              data: bxbDxbNum
            },
            {
              name: '中型坝',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#1CEA58",
                    },
                    {
                      offset: 1,
                      color: "#1CEA58",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: bxbZxbNum
            },
            {
              name: '大型有人坝',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00B3FE ",
                    },
                    {
                      offset: 1,
                      color: "#00B3FE",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: bxbDxbYrNum
            },
            {
              name: '中型有人坝',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#B32EFF ",
                    },
                    {
                      offset: 1,
                      color: "#B32EFF",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: bxbZxbYrNum
            },
          ]
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      //预报页面不同降雨量影响淤地坝统计柱图
      jytjbar(jytjCityId, jytjCityName, a10Sum, a25Sum, a50Sum, a100Sum, a250Sum, a255Sum) {
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '2%',
            bottom: '0%',
            top: '10%',
            containLabel: true
          },
          legend: {
            data: ['10mm', '25mm', '50mm', '100mm', '250mm', '>250mm'],
            // right: 'center',
            top: 0,
            textStyle: {
              color: "#fff",
              fontSize: 16
            },
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 10
          },
          xAxis: {
            type: 'category',
            data: jytjCityName,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              textStyle: {
                fontFamily: 'Microsoft YaHei',
                fontSize: 16
              }
            },
          },
          yAxis: {
            name: "数量",
            type: 'value',
            // max: '1200',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ccc'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {
              fontSize: 16
            }
          },
          series: [{
              name: '10mm',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#a5f38d ",
                    },
                    {
                      offset: 1,
                      color: "#a5f38d",
                    },
                  ]),
                  // barBorderRadius: 12,
                },
              },
              data: a10Sum
            },
            {
              name: '25mm',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#39aa00",
                    },
                    {
                      offset: 1,
                      color: "#39aa00",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: a25Sum
            },
            {
              name: '50mm',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#63baff",
                    },
                    {
                      offset: 1,
                      color: "#63baff",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: a50Sum
            },
            {
              name: '100mm',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#0000fe",
                    },
                    {
                      offset: 1,
                      color: "#0000fe",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: a100Sum
            },
            {
              name: '250mm',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ff00fe",
                    },
                    {
                      offset: 1,
                      color: "#ff00fe",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: a250Sum
            },
            {
              name: '>250mm',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#720000",
                    },
                    {
                      offset: 1,
                      color: "#720000",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: a255Sum
            },
          ]
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      //预警淤地坝数量统计饼图(所有预警饼图)
      slbarNew1(yxrsCityName, YblueSum, YyellowSum, YorangeSum, YredSum) {
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));
        this.AllNum = Number(YyellowSum) + Number(YorangeSum) + Number(YredSum);

        let  option = {
          legend: {
            left:'center',
            top:5,
            data:[{name:"四级"},{name: "三级"},{name:"二级"},{name: "一级"}],
            textStyle:{
              color:'#fff',
              fontSize: 16
            },
            selected: {
              '四级': false
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: yxrsCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '80%'],
              label: {
                position: 'inner',
                fontSize: 16,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: YblueSum, name: "四级",itemStyle:{color:'#00B3FE'}},
                { value: YyellowSum, name: "三级",itemStyle:{color:'#FFE557'}},
                { value: YorangeSum, name: "二级",itemStyle:{color:'#ffa500'}},
                { value: YredSum, name: "一级",itemStyle:{color:'#ff2d51'}},
              ]
            },
          ]
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      //预警淤地坝数量统计饼图(所有预警双饼图)
      slbarNew(xzqhCityName, dxBlueSum, dxYellowSum, dxOrangeSum, dxRedSum, zxBlueSum, zxYellowSum, zxOrangeSum, zxRedSum) {
        let _this = this;
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));

        if (this.bigData.type == "yjbxb" || this.bigData.type == "yjljb" || this.bigData.type == 'yjbxljyx') {
          this.bxNum = Number(dxYellowSum) + Number(dxOrangeSum) + Number(dxRedSum);
          this.bxyrNum = Number(zxYellowSum) + Number(zxOrangeSum) + Number(zxRedSum);
        } else {
          this.AllNum = Number(dxYellowSum) + Number(dxOrangeSum) + Number(dxRedSum) +
          Number(zxYellowSum) + Number(zxOrangeSum) + Number(zxRedSum);
        }
        let text1, text2;
        if (this.bigData.type == "yjydbNum") {
          text1 = '大型坝';
          text2 = '中型坝';
        } else if (this.bigData.type == "yjbxb") {
          text1 = '病险坝';
          text2 = '病险有人坝';
        } else if (this.bigData.type == "yjljb") {
          text1 = '老旧坝';
          text2 = '老旧有人坝';
        }

        let  option = {
          title : [{
              text: text1,
              left: '23%',
              bottom: '2%',
              x:'center',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 16,
                  color: '#fff'
              },
          }, {
              text: text2,
              left: '73%',
              bottom: '2%',
              x:'center',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 16,
                  color: '#fff'
              },
          }],
          legend: {
            left:'center',
            top:5,
            data:[{name:"四级"},{name: "三级"},{name: "二级"},{name: "一级"}],
            textStyle:{
              color:'#fff',
              fontSize: 16
            },
            selected: {
              '四级': false
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: xzqhCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '80%'],
              center: ['25%', '50%'],
              label: {
                position: 'inner',
                fontSize: 16,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: dxBlueSum, name: "四级",itemStyle:{color:'#00B3FE'}},
                { value: dxYellowSum, name: "三级",itemStyle:{color:'#FFE557'}},
                { value: dxOrangeSum, name: "二级",itemStyle:{color:'#ffa500'}},
                { value: dxRedSum, name: "一级",itemStyle:{color:'#ff2d51'}},
              ]
            },
            {
              type: 'pie',
              radius: [0, '80%'],
              center: ['75%', '50%'],
              label: {
                position: 'inner',
                fontSize: 16,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: zxBlueSum, name: "四级",itemStyle:{color:'#00B3FE'}},
                { value: zxYellowSum, name: "三级",itemStyle:{color:'#FFE557'}},
                { value: zxOrangeSum, name: "二级",itemStyle:{color:'#ffa500'}},
                { value: zxRedSum, name: "一级",itemStyle:{color:'#ff2d51'}},
              ]
            },
          ]
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      //预警淤地坝数量统计柱图(所有预警相关柱图)
      slbar(xzqhCityId, xzqhCityName, BlueSum, YellowSum, OrangeSum, RedSum) {
        this.Bar = this.$echarts.init(document.getElementById("bigEcharts"));

        let option = {
          title: {
            show: false,
            text: "",
            textStyle: {
              fontSize: 25,
              fontWeight: "normal",
              color: "#fff",
            },
            x: "center",
          },

          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: "2%",
            right: "2%",
            bottom: "0%",
            top: "10%",
            containLabel: true,
          },
          legend: {
            data: ["四级", "三级", "二级", "一级"],
            /*right: 10,*/
            // top: "4%",
            textStyle: {
              color: "#fff",
              fontSize: 16
            },
            itemWidth: 12,
            itemHeight: 10,
            // itemGap: 35
            selected: {
              '四级': false
            },
          },
          xAxis: {
            type: "category",
            data: xzqhCityName,
            axisLine: {
              lineStyle: {
                color: "#ccc",
              },
            },
            axisLabel: {
              // interval: 0,
              // rotate: 40,
              textStyle: {
                fontFamily: "Microsoft YaHei",
                fontSize: 16
              },
            },
          },

          yAxis: {
            name: "数量",
            type: "value",
            // max: "150",
            axisLine: {
              show: false,
              lineStyle: {
                color: "#ccc",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,0.3)",
              },
            },
            axisLabel: {
              fontSize: 16
            },
          },

          series: [{
              name: "四级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00B3FE",
                    },
                    {
                      offset: 1,
                      color: "#00B3FE",
                    },
                  ]),
                },
              },
              data: BlueSum,
            },
            {
              name: "三级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                },
              },
              data: YellowSum,
            },
            {
              name: "二级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ffa500",
                    },
                    {
                      offset: 1,
                      color: "#ffa500",
                    },
                  ]),
                },
              },
              data: OrangeSum,
            },
            {
              name: "一级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ff2d51",
                    },
                    {
                      offset: 1,
                      color: "#ff2d51",
                    },
                  ]),
                },
              },
              data: RedSum,
            },
          ],
        };
        this.Bar.clear();
        this.Bar.setOption(option);
      },

      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },

      cancel() { //取消
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },
    }
  }
</script>

<style scoped>
  >>>.el-dialog {
    height: 700px;
    background: url(../../common/images/dialog.png) no-repeat center;
    background-size: 100% 100%;
  }

  >>>.el-dialog__body {
    height: 610px;
    padding-top: 0;
  }

  >>>.el-dialog__header {
    /* border: none; */
    padding-left: 0;
    margin: 10px 20px 8px 20px;
  }
  
  >>>.el-dialog__body, .el-dialog__footer{
      background: transparent;
  }

  .Piebar {
    width: 100%;
    height: 100%;
  }
</style>
